
import classNames from 'classnames';
import React from 'react';
import iconMap from './IconMapping';
import PropTypes from 'prop-types';

const Icon = ({
	dataTestId = 'icon',
	name,
	style,
	size,
	color = '#60636b',
	disabled = false,
	selected = false
}) => {
	const iconClass = classNames({
		DS__icon: true,
		'DS__icon--small': size === 'small',
		'DS__icon--medium': size === 'medium',
		'DS__icon--large': size === 'large',
		'DS__icon--selected': selected,
		'DS__icon--disabled': disabled
	});

	const iconStyle = {
		color
	};

	const IconComponent = iconMap[name]?.[style];

	if (!IconComponent) {
		return null;
	}

	return (
		<div className={iconClass} style={iconStyle} data-testid={dataTestId}>
			<IconComponent />
		</div>
	);
};

Icon.propTypes = {
	dataTestId: PropTypes.string,
	name: PropTypes.string.isRequired,
	style: PropTypes.string.isRequired,
	size: PropTypes.oneOf(['small', 'medium', 'large']),
	color: PropTypes.string,
	disabled: PropTypes.bool,
	selected: PropTypes.bool
};

// Default prop values (if any):
Icon.defaultProps = {
	dataTestId: 'icon',
	color: '#60636b',
	disabled: false,
	selected: false
};

export default Icon;
